const t = "_tabs_1rlee_1", s = "_tab_1rlee_1", a = {
  tabs: t,
  tab: s
};
export {
  a as default,
  s as tab,
  t as tabs
};
//# sourceMappingURL=tabs.module.less.js.map
